// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#y-label {
  font-size: 11px;
  padding-right: 8px;
}

#x-labels-list {
  font-size: 14px;
}

#heatmap-container {
  display: flex;
  gap: 10px;
}

#heatmap-left {
  width: 100%;
}

#heatmap-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 30px;
  font-size: 13px;
  margin-bottom: 27px;
}


`, "",{"version":3,"sources":["webpack://./src/pages/Statistics.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["#y-label {\n  font-size: 11px;\n  padding-right: 8px;\n}\n\n#x-labels-list {\n  font-size: 14px;\n}\n\n#heatmap-container {\n  display: flex;\n  gap: 10px;\n}\n\n#heatmap-left {\n  width: 100%;\n}\n\n#heatmap-right {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 30px;\n  font-size: 13px;\n  margin-bottom: 27px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
